// tslint:disable:max-line-length no-console

import * as Redux from "redux";
import { api } from "./api/system/apiClient";
import { SharedActions } from "./flux/actions/sharedActions";

/**
 * Log an error message to the TravelLocal api.
 * @param error an instance of Error, or a message.
 * @param dispatch redux's dispatch function (optional)
 */
export async function handleError(error: Error | string, dispatch?: Redux.Dispatch<any>) {
  const details = typeof error === "string"
    ? { message: error }
    : { message: error.message, stack: error.stack };

  try {
    const result = await api.logError(details);

    if (dispatch) {
      dispatch({ type: SharedActions.Errors.DisplayError, error, code: result.json.code });
    }

    console.error(`Sorry, something went wrong: ${details.message}. If you are reading this message then we have been notified. Please try again.`);
  }
  catch (e) {
    console.error(`Sorry, something went wrong: ${details.message}. But we weren't able to notify our server about it: ${e.message || e}. If you're reading this, we would greatly appreciate if you sent this message to development@travellocal.com. Thanks!`, e);

    if (dispatch) {
      dispatch({ type: SharedActions.Errors.DisplayError, e });
    }
  }
}
